export const ListUOMCategory = () => {
  const list = [
    { label: 'Length', value: 'L' },
    { label: 'Weight', value: 'W' },
    { label: 'Volume', value: 'V' },
    { label: 'Temperature', value: 'T' },
  ];

  return list;
}